// Клавишен chip за подсказките в работните листове (празното състояние,
// търсачката): surface, долна рамка 2px shade-4, mono 10/600 — по
// .design-sync/guidelines/40-inventory.md.
import type { ReactNode } from "react";

export const KbdChip = ({ children }: { children: ReactNode }) => (
  <span className="inline-block rounded border border-b-2 border-shade-4 bg-surface px-[5px] pb-[2px] pt-px align-middle font-[ui-monospace,Menlo,monospace] text-[10px] font-semibold leading-[normal] text-soft">
    {children}
  </span>
);

export default KbdChip;
